module.exports = __webpack_public_path__ + "img/close-ticket.ea3b98f2.svg";